import { useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { getTestIds } from 'seagull/utils/TestIds';
import { LegalTerms } from "../../AgreementStudioPage/AgreementStudioModal/LegalTerms/LegalTerms";
import AmendmentChanges from "../../AmendmentChanges/AmendmentChanges";
import { SettingsField } from "../EditAgreementComponents";
import { useEditAgreementForm } from "../utils/EditAgreementModal.utils";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  EditLegalTermsTID
} = getTestIds();
export function EditLegalTerms(props) {
  const {
    relationship
  } = props;
  const {
    watch,
    setValue,
    formState,
    control
  } = useEditAgreementForm();
  const [resetLocalContentKey, setResetLocalContentKey] = useState(0);
  const isSelectedLegalTermsDirty = formState.dirtyFields.selectedLegalTerms === true;
  const selectedLegalTerms = watch('selectedLegalTerms');
  const itemErrors = useMemo(() => {
    var _selectedLegalTerms$m;
    return (_selectedLegalTerms$m = selectedLegalTerms === null || selectedLegalTerms === void 0 ? void 0 : selectedLegalTerms.map(lt => ({
      legalTermField: lt === null ? 'Please choose a document' : undefined
    }))) !== null && _selectedLegalTerms$m !== void 0 ? _selectedLegalTerms$m : [];
  }, [selectedLegalTerms]);
  const validateSelectedLegalTerms = value => {
    return value.some(lt => lt === null) ? false : undefined;
  };
  return /*#__PURE__*/_jsx(SettingsField, {
    children: /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "selectedLegalTerms",
      rules: {
        validate: validateSelectedLegalTerms
      },
      render: _ref => {
        let {
          field,
          fieldState,
          formState
        } = _ref;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(LegalTerms, {
            testId: EditLegalTermsTID.LegalTermsDropdown(),
            agreementLegalTerms: field.value,
            errors: formState.isSubmitted && fieldState.error ? itemErrors : [],
            onAgreementLegalTermsChange: agreementLegalTerms => {
              setValue('selectedLegalTerms', agreementLegalTerms, {
                shouldDirty: true,
                shouldValidate: true
              });
            },
            editContext: "agreement",
            sourceId: relationship.id,
            resetLocalContentKey: resetLocalContentKey
          }), isSelectedLegalTermsDirty && /*#__PURE__*/_jsx(AmendmentChanges, {
            isUnsaved: true,
            disableNote: true,
            disableBorderRadius: true,
            items: [{
              text: "Terms of Service updated"
            }],
            testId: EditLegalTermsTID.AmendmentChanges(),
            autoApprovalDate: null,
            onDiscard: () => {
              setValue('selectedLegalTerms', relationship.legalTermsDocuments, {
                shouldDirty: true
              });
              setResetLocalContentKey(prev => prev + 1);
            }
          })]
        });
      }
    })
  });
}